module.exports = __webpack_public_path__ + "img/interUnsel.7411089c.svg";